exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(true);
// imports


// module
exports.push([module.id, ".triangle-header{position:relative}.triangle-header canvas{width:100%;display:block}@media only screen and (max-width:1023px){.triangle-header canvas{height:175px}}", "", {"version":3,"sources":["/home/runner/work/manager/manager/src/components/TriangleHeader.vue"],"names":[],"mappings":"AACA,iBACE,iBAAmB,CACpB,AACD,wBACE,WAAY,AACZ,aAAe,CAChB,AACD,0CACA,wBACI,YAAc,CACjB,CACA","file":"TriangleHeader.vue","sourcesContent":["\n.triangle-header {\n  position: relative;\n}\n.triangle-header canvas {\n  width: 100%;\n  display: block;\n}\n@media only screen and (max-width: 1023px) {\n.triangle-header canvas {\n    height: 175px;\n}\n}"],"sourceRoot":""}]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"minimize":true,"sourceMap":true}!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-1dc8603f","scoped":false,"hasInlineConfig":false}!./node_modules/stylus-loader?{"sourceMap":true}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/TriangleHeader.vue
// module id = 925
// module chunks = 0